import { render, staticRenderFns } from "./FooterLight.vue?vue&type=template&id=7ddc8738&"
import script from "./FooterLight.vue?vue&type=script&lang=js&"
export * from "./FooterLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports